import type { SVGProps } from 'react'
const SvgSyArrowLeftDownSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M4.3 17.3 21 .7 23.3 3 6.7 19.7h12.6V23H1V4.7h3.3z" />
	</svg>
)
export default SvgSyArrowLeftDownSystem
